import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { LanguageProvider } from './lib/i18n'
import { FontSizeProvider } from './contexts/FontSizeContext'
import { AuthProvider, useAuth } from './lib/AuthContext'
import { ThemeProvider } from './lib/theme'
import { AppLayout } from './layouts/AppLayout'
import { Dashboard } from './pages/Dashboard'
import { ChatPage } from './pages/ChatPage'
import { KnowledgeBase } from './pages/KnowledgeBase'
import { LegalBaseDetail } from './pages/LegalBaseDetail'
import { MatterList } from './pages/MatterList'
import { LegalBase } from './pages/LegalBase'
import { Templates } from './pages/Templates'
import { Settings } from './pages/Settings'
import { MatterDetail } from './pages/MatterDetail'
import { Help } from './pages/Help'
import { RecycleBin } from './pages/RecycleBin'
import { Login } from './pages/Login'
import { Register } from './pages/Register'

function RequireAuth() {
  const { isLoggedIn } = useAuth()
  if (!isLoggedIn) return <Navigate to="/login" replace />
  return <Outlet />
}

function GuestOnly() {
  const { isLoggedIn } = useAuth()
  if (isLoggedIn) return <Navigate to="/" replace />
  return <Outlet />
}

export default function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
      <FontSizeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes (only for unauthenticated users) */}
            <Route element={<GuestOnly />}>
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />
            </Route>

            {/* Protected routes */}
            <Route element={<RequireAuth />}>
              <Route element={<AppLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="chat" element={<ChatPage />} />
                <Route path="knowledge" element={<KnowledgeBase />} />
                <Route path="legal-base/:topicKey" element={<LegalBaseDetail />} />
                <Route path="matters" element={<MatterList />} />
                <Route path="matters/:matterId" element={<MatterDetail />} />
                <Route path="legal-base" element={<LegalBase />} />
                <Route path="templates" element={<Templates />} />
                <Route path="settings" element={<Settings />} />
                <Route path="help" element={<Help />} />
                <Route path="recycle-bin" element={<RecycleBin />} />
              </Route>
            </Route>

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      </FontSizeProvider>
      </ThemeProvider>
    </LanguageProvider>
  )
}
